module.exports = __webpack_public_path__ + "static/media/dodge.963e7b07.gltf";